
import Holidays from "date-holidays";

export default {
  data() {
    return {
      filters: [],
      publicCroatianHolidays: [],
      activeMapIndex: 0,
      options: [
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
      ],
      locationOptions: [
        {
          name: "name",
          label: this.$t("label.locationName"),
          type: "text",
        },
        {
          name: "checkForEvenDate",
          label: this.$t("label.checkForEvenDate"),
          type: "checkbox",
        },
        {
          name: "workingHoursEveryDay",
          label: this.$t("label.workingHoursEveryDay"),
          type: "text",
        },
        {
          name: "locationCoordinates",
          label: this.$t("label.coordinates"),
          type: "coordinates",
        },
        {
          name: "evenDate",
          label: this.$t("label.evenDate"),
          type: "text",
        },
        {
          name: "unevenDate",
          label: this.$t("label.unevenDate"),
          type: "text",
        },
        {
          name: "saturday",
          label: this.$t("label.saturday"),
          type: "text",
        },
        {
          name: "sunday",
          label: this.$t("label.sunday"),
          type: "text",
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      if (
        this.$refs.filter &&
        this.$refs.filter.items &&
        this.$refs.filter.items.length
      ) {
        this.filters = this.$refs.filter.items;
      }

      this.getPublicHolidays();

      this.setZoomAndCenter(0);
    });
  },

  methods: {
    setZoomAndCenter(i) {
      if (this.$refs[`map_${i}`]) {
        const mapChild = this.$refs[`map_${i}`].$children[0];

        mapChild.setZoom(20);

        if (
          this.$refs[`locations${i}`] &&
          this.$refs[`locations${i}`].items &&
          this.$refs[`locations${i}`].items[0] &&
          this.$refs[`locations${i}`].items[0].locationCoordinates
        ) {
          const lat =
            this.$refs[`locations${i}`].items[0].locationCoordinates.lat;
          const long =
            this.$refs[`locations${i}`].items[0].locationCoordinates.long;
          mapChild.setCenter([lat, long]);
        }
      }
    },
    setActiveMap(index) {
      this.activeMapIndex = index;

      setTimeout(() => {
        this.setZoomAndCenter(index);
      }, 50);
    },

    getPublicHolidays() {
      const date = new Date();
      const year = date.getFullYear();
      var holidaysCroatia = new Holidays();
      holidaysCroatia.init("HR");

      const croatianHolidays = holidaysCroatia.getHolidays(year);

      this.publicCroatianHolidays = croatianHolidays.filter(
        (holiday) => holiday.type === "public"
      );
    },

    returnWorkingHours(location) {
      if (!location) return;

      var isHoliday = this.returnIfTodaysHoliday();

      if (!location.evenDate) {
        location.evenDate = this.$t("text.closed");
      } else if (!location.unevenDate) {
        location.unevenDate = this.$t("text.closed");
      } else if (!location.saturday) {
        location.saturday = this.$t("text.closed");
      } else if (!location.sunday) {
        location.sunday = this.$t("text.closed");
      }

      const date = new Date();
      const weekDay = date.getDay();
      const dateDay = date.getDate();

      let workingHours;
      var saturday = false;
      var sunday = false;
      var evenDate = false;

      if (dateDay % 2 === 0) {
        evenDate = true;
      } else evenDate = false;

      if (weekDay === 6) {
        saturday = true;
      } else if (weekDay === 7) {
        sunday = true;
      }

      if (saturday) {
        workingHours = location.saturday;
      } else if (sunday) {
        workingHours = location.sunday;
      } else if (evenDate) {
        workingHours = location.evenDate;
      } else {
        workingHours = location.unevenDate;
      }

      if (isHoliday) {
        workingHours = this.$t("text.closed");
      }

      return workingHours;
    },

    returnIfTodaysHoliday() {
      var isHoliday = false;
      const currentDate = new Date();
      const currentDay = currentDate.getDate();
      const currentMonth = currentDate.getMonth();

      this.publicCroatianHolidays.forEach((holiday) => {
        const holidayDate = new Date(holiday.date);
        const holidayDay = holidayDate.getDate();
        const holidayMonth = holidayDate.getMonth();

        if (holidayDay === currentDay && holidayMonth === currentMonth) {
          isHoliday = true;
        }
      });

      return isHoliday;
    },
  },
};
